module.exports = __webpack_public_path__ + "img/prisons.4fe6346a.jpg";